var map = {
	"./active-shade.png": "a808",
	"./area-limit-arrow.png": "6bde",
	"./area-limit-bg.png": "4319",
	"./area-limit-btn-disabled.png": "f7b1",
	"./area-limit-btn.png": "af18",
	"./area-limit-cancel-btn.png": "70b7",
	"./bank-info-bg.png": "1060",
	"./bank-input.png": "014c",
	"./bank-submit-h.png": "efb6",
	"./bank-submit.png": "fc08d",
	"./banner-hen-jp.png": "56c9",
	"./banner-hen-kr.png": "9795",
	"./banner-hen.png": "31b2",
	"./banner-jp.png": "d8eb",
	"./banner-kr.png": "3158",
	"./banner.png": "d7b1",
	"./bg-hen.png": "2a81",
	"./bg.png": "a920",
	"./cancel-hen.png": "e84f",
	"./cancel.png": "bbf02",
	"./cart-buy-hen.png": "3829",
	"./cart-buy.png": "fcdb",
	"./cart-double-tip-ico.png": "42fe",
	"./cart-list-bg-hen.png": "d2d3",
	"./cart-list-bg.png": "a2ef",
	"./cart-list-fold-ico.png": "5cf4",
	"./cart-list-item-bg.png": "e58cf",
	"./channel-bg.png": "ac5c",
	"./child-channel-bg.png": "4aa6",
	"./child-channel-ico.png": "71aa",
	"./choose-box-hen.png": "abad2",
	"./choose-box.png": "161b",
	"./close-hen.png": "67ee",
	"./close.png": "d9ae",
	"./coin.png": "d8a6",
	"./common-popup-hen.png": "8e95",
	"./common-popup.png": "6473",
	"./confirm-hen.png": "925b",
	"./confirm.png": "5683",
	"./coupon-item-choose-ico-rtl.png": "d56a",
	"./coupon-item-choose-ico.png": "a31c",
	"./coupon-item-invalid-bg.png": "6609",
	"./coupon-item-shade.png": "b8ca",
	"./coupon-item-valid-bg.png": "3026",
	"./coupon-popup-bg-hen.png": "25a1",
	"./coupon-popup-bg.png": "658d",
	"./coupon-popup-item-empty-hen.png": "39be",
	"./coupon-popup-item-empty.png": "f74c",
	"./coupon-popup-item-use-hen.png": "fbb3",
	"./coupon-popup-item-use-hen.png.png": "fa0a",
	"./coupon-popup-item-use.png": "cc8b",
	"./coupon-tag-close.png": "f12e",
	"./credit-card-active.png": "1c2f",
	"./currency.png": "7e8f",
	"./delete.png": "2e54",
	"./detail-bg-hen.png": "faae",
	"./detail-bg.png": "c357",
	"./detail-btn-hen.png": "e85d",
	"./detail-btn.png": "d96a",
	"./detail-popup-hen.png": "caba",
	"./detail-popup.png": "5373",
	"./down.png": "9b62",
	"./dzg.png": "0ee9",
	"./dzg_jp.png": "6804",
	"./dzg_kr.png": "8caf",
	"./dzg_vi.png": "278e",
	"./footer-safe-icon-1.png": "49b8",
	"./footer-safe-icon-2.png": "3bb9",
	"./footer-safe-icon-3.png": "8ba5",
	"./footer-safe-icon-4.png": "f3e0",
	"./header-safe-icon.png": "9d52",
	"./icon209.png": "4194",
	"./icon211.png": "5e74",
	"./icon213.png": "9623",
	"./icon215.png": "410d",
	"./lang-ico.png": "03ff",
	"./link-banner-ar.png": "c84e",
	"./link-banner-cn.png": "29ad",
	"./link-banner-de.png": "c7ec",
	"./link-banner-en.png": "169d",
	"./link-banner-es.png": "b8a1",
	"./link-banner-fr.png": "02c5",
	"./link-banner-id.png": "5f50",
	"./link-banner-it.png": "1d50",
	"./link-banner-jp.png": "42d4",
	"./link-banner-kr.png": "3d2b",
	"./link-banner-pl.png": "adc5",
	"./link-banner-pt.png": "4c12",
	"./link-banner-ru.png": "bc3d",
	"./link-banner-th.png": "95d4",
	"./link-banner-tr.png": "d6ed",
	"./link-banner-tw.png": "c065",
	"./link-banner-vi.png": "c1fa",
	"./login-safe-spinning.png": "799d",
	"./login-safe-success.png": "1733",
	"./logo-hen.png": "a6c5",
	"./logo-jp.png": "c8af6",
	"./logo-kr.png": "fbfa",
	"./logo-th.png": "e7b5",
	"./logo-vn.png": "068a",
	"./logo.png": "8f515",
	"./look-detail-hen.png": "bc77",
	"./look-detail.png": "e326",
	"./look-jiantou-hen.png": "d363",
	"./look-jiantou.png": "9e8e",
	"./name-shade.png": "dcba",
	"./normal-buy-hen.png": "4754",
	"./normal-buy.png": "cc67",
	"./normal-login.png": "a699",
	"./order-btn-active.png": "0100",
	"./order-btn.png": "6bd2",
	"./order-coupon.png": "0378",
	"./order-detail-content-bg-hen.png": "de21",
	"./order-detail-content-bg.png": "d8b4",
	"./order-ico.png": "fff6",
	"./package.png": "ea72",
	"./paytype-bottom-hen.png": "3e63",
	"./paytype-bottom.png": "0758",
	"./paytype-center-hen.png": "72f7",
	"./paytype-center.png": "fdc4",
	"./paytype-more.png": "72cc",
	"./paytype-name-bg.png": "1a02",
	"./paytype-top-hen.png": "3022",
	"./paytype-top.png": "abd4",
	"./payway-select-items-hasother.png": "4ff6",
	"./payway-select-items.png": "8b0b",
	"./pointcard-bg.png": "867a",
	"./pointcard-btn.png": "7cdf",
	"./pointcard-input.png": "4541",
	"./price-hen.png": "e0c4",
	"./price.png": "a7fc",
	"./product-detail-bg.png": "ff50",
	"./product-hen.png": "1130",
	"./product-item-bg.png": "4b08",
	"./product-item-fenge.png": "5d64",
	"./product-type-item-bg-active.png": "275d",
	"./product-type-item-bg.png": "5d86",
	"./product-type-wrap-bg.png": "00337",
	"./product-wrap-bg-hen.png": "7482",
	"./product-wrap-bg-selected-hen.png": "92db",
	"./product-wrap-bg-selected.png": "5ff7",
	"./product-wrap-bg.png": "1e8d",
	"./product.png": "58a1",
	"./prop-item-bg.png": "8992",
	"./prop-popup.png": "2fa3",
	"./pwa-install-popup-bg.png": "906f",
	"./pwa-install-popup-btn.png": "2f5e",
	"./pwa-install.png": "a402",
	"./pwa-installed-award.png": "0663",
	"./pwa-role-bind.png": "2387",
	"./pwa-role-select-hen.png": "7ae2",
	"./pwa-role-select.png": "a323",
	"./result-banner.png": "848e",
	"./result-bg-hen.png": "9281",
	"./result-bg-top.png": "6576",
	"./result-bg.png": "55ec",
	"./result-cart-order-bg.png": "e4df",
	"./result-contact-btn.png": "279c",
	"./result-fail-ico.png": "b2ff",
	"./result-heng-shao.png": "25a7",
	"./result-info-bg.png": "7270",
	"./result-restore-btn.png": "455d",
	"./result-storing-ico.png": "1f95",
	"./result-succ-ico.png": "6695",
	"./return.png": "f046",
	"./role-choose.png": "78ff",
	"./role-ico.png": "3498",
	"./search-bg.png": "f3bc",
	"./search-ico-shu.png": "eaa0",
	"./search-ico.png": "fb64",
	"./search-input-hen.png": "0dd5",
	"./search-input-ico.png": "c71a",
	"./search-input.png": "56cd",
	"./search-type.png": "7aa2",
	"./service-ico.png": "f31d",
	"./submit-h.png": "e6d26",
	"./submit-hen.png": "7fa5",
	"./submit.png": "4580",
	"./subscription.png": "3f9e",
	"./switch-area-ico.png": "6c0b",
	"./title-bg.png": "f2ea",
	"./token.png": "ee37",
	"./top-bg-hen.png": "1d19",
	"./top-bg.png": "ef1d",
	"./typeall.png": "2ed6",
	"./uid-ask-ico.png": "7568",
	"./uid-input-bg.png": "4560",
	"./uid-input.png": "a913",
	"./uid-login.png": "4e4e",
	"./uid-popup-hen.png": "6049",
	"./uid-popup.png": "7b89",
	"./uid-search-btn.png": "9c69",
	"./uid-succ-ico.png": "d7f1",
	"./uid-token-ask.png": "2253",
	"./uid-token-bg-hen.png": "c664",
	"./uid-token-bg.png": "1c6f",
	"./uid-token-btn.png": "b47e",
	"./uid-token-dynamic-input.png": "3756",
	"./uid-token-game-guide-global-vi.png": "5289",
	"./uid-token-game-guide-global.png": "26dc",
	"./uid-token-game-guide-jp.png": "12a4",
	"./uid-token-game-guide-kr.png": "3afc",
	"./uid-token-game-guide-th.png": "56c5",
	"./uid-token-login.png": "339f",
	"./uid-token-refresh.png": "fbe5",
	"./uid-token-return-ico.png": "3dc0",
	"./uid-token-uid-input.png": "4ced",
	"./uid-token-vertification-input.png": "139d",
	"./vip-coupon-btn-bg.png": "adff",
	"./vip-coupon-ratio.png": "1853"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "278f";